import { runInAction } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { PhoneInput, PhoneInputProps } from './PhoneInput';

interface PhoneInputFieldProps extends Omit<PhoneInputProps, 'value' | 'onChange'> {
	/** A MobX-observable model whose `modelProperty` holds the phone number (E.164). */
	model: any;
	modelProperty: string;
	onAfterChange?: (value: string) => void;
}

/**
 * MobX-model-bound wrapper around {@link PhoneInput}, mirroring the `model`/`modelProperty` API of
 * the legacy `TextField`. Writes the E.164 value back into the model inside `runInAction`.
 */
export const PhoneInputField = observer(({ model, modelProperty, onAfterChange, ...rest }: PhoneInputFieldProps) => (
	<PhoneInput
		{...rest}
		value={model[modelProperty] ?? ''}
		onChange={value => {
			runInAction(() => {
				model[modelProperty] = value;
			});
			onAfterChange?.(value);
		}}
	/>
));
